module.exports = __webpack_public_path__ + "static/media/cg.a7e2dd95.svg";